import React from 'react';
import SuperProfilePublicDescriptionInput from './SuperProfilePublicDescriptionInput';
import SuperProfileInternalNameInput from './SuperProfileInternalNameInput';
import SuperProfilePublicTitleInput from './SuperProfilePublicTitleInput';

const JobProfileInput = () => {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SuperProfileInternalNameInput />
        <SuperProfilePublicTitleInput />
        <SuperProfilePublicDescriptionInput />
      </div>
    </div>
  );
};

export default JobProfileInput;
